<template>
  <v-form v-model="valid" ref="mainForm">

    <opq-memo
      code="enquete_objetdemande"
      v-model="sasDemandeEnquete.objetDeLaDemande"
      :live="liveSasDemandeEnquete(23339)"
    ></opq-memo>

    <opq-catalogue
      code="enquete_joindrepreuve"
      v-model="sasDemandeEnquete.joindrePreuve"
      :live="liveSasDemandeEnquete(23342)"
    ></opq-catalogue>

    <opq-file-multiple
      :opq-if="estOuiJoindrePreuve"
      code="enquete_preuve"
      :files="sasDemandeEnquete.preuves"
      :live="liveSasDemandeEnquete(23341)"
    ></opq-file-multiple>

  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"

export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasDemandeEnquete() {
      return this.sas.sasDemandeEnquete
    },

    estOuiJoindrePreuve() {
      return this.estOui(this.sasDemandeEnquete.joindrePreuve)
    },
  },

  methods: {
    liveSasDemandeEnquete(cle) {
      return { endpoint: "/sas-demande-enquete/", cle: cle, fileId: this.sasDemandeEnquete.id }
    }
  }
}
</script>

<style>
</style>